import { render } from "./CollapsableText.vue?vue&type=template&id=71b2a8bf"
import script from "./CollapsableText.vue?vue&type=script&lang=js"
export * from "./CollapsableText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__